import { useEffect } from 'react';
import { Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { } from "smash-idhelper";
import DashboardPage from '../../components/DashboardPage/DashboardPage';
import ToasterList, { useToaster } from '../../components/Toaster/ToasterList';
import DomainAuthenticationMode from '../../features/domains/components/DomainAuthenticationMode';
import { domainState, getDomainDetails, resetDomainDetails ,resetUpdateTeamConfiguration } from '../../features/domains/domainSlice';
import { useAppDispatch, useAppSelector } from '../../hooks/redux/hooks';

const DomainDetails = () => {

    let { id } = useParams();
    const { domainDetails, updatedDomain } = useAppSelector(domainState);
    const { details } = domainDetails;
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!details && id) {
            dispatch(getDomainDetails({ teamId: id }));
        }

        if (updatedDomain.isSuccess === true) {
            addToast({ idx: 'domainUpdated', theme: 'success', title: 'Success', body: () => (<>Domain "{domainDetails?.details?.domain?.domain}" successfully updated !</>) });
            dispatch(resetUpdateTeamConfiguration());
        }
    }, [domainDetails, updatedDomain]);

    useEffect(() => {
        dispatch(resetDomainDetails());
    }, []);

    const { toastList, addToast } = useToaster();

    return (
        <>
            <DashboardPage heading={`Settings > ${domainDetails.details?.domain?.domain || ''}`}>
                <Col className="w-50">
                    <DomainAuthenticationMode domain={domainDetails.details} updating={updatedDomain?.isLoading} updated={updatedDomain?.isSuccess}></DomainAuthenticationMode>
                </Col>
            </DashboardPage>
            <ToasterList list={toastList} />
        </>
    )
}

export default DomainDetails